import { render } from "./IntegrationsItem.vue?vue&type=template&id=0ea8de42"
import script from "./IntegrationsItem.vue?vue&type=script&lang=js"
export * from "./IntegrationsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__